module.exports = __webpack_public_path__ + "static/media/LI-In-Bug.c6222e45.png";